module.exports = __webpack_public_path__ + "static/img/headshot.e5fd276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headshot.png
// module id = 28
// module chunks = 1